
  import { Component, Vue } from 'vue-property-decorator';
  import { mapGetters } from 'vuex';

  import { IUserModel } from '@/models/account.model';
  import { IOptInRequestModel, IOptInModel, IOptInListResultModel, IOptInRequestResponseModel } from '@/models/newsletter.model';

  import errorsService from '@/services/errors.service';
  import accountService from '@/services/account.service';

  @Component({
    computed: {
      ...mapGetters([
        'user'
      ])
    }
  })
  export default class Newsletter extends Vue {
    data() {
      return {
        optInList: [] as Array<IOptInModel>,
        isLoading: false,
        errors: [] as Array<string>,
        unwatch: null
      }
    };

    created() {
      this.$data.unwatch = this.$store.watch(() => this.$store.getters.user, user => {
        this.setOptInList(user);
      });

      if (this.$store.getters.user.Id != null) {
        this.setOptInList(this.$store.getters.user);
      }
    };

    setOptInList(user: IUserModel) {
      this.$store.dispatch("updateIsLoading", true);
      this.$data.isLoading = true;

      const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "newsletter";

      accountService.get<IOptInListResultModel>(this, url, { headers: { Authorization: "Bearer " + this.$store.getters.token.Value } })
        .then(optInList => {
          this.$store.dispatch("updateIsLoading", false);
          this.$data.isLoading = false;
          this.$data.optInList = optInList.OptInList;
        })
        .catch(error => {
          this.$store.dispatch("updateIsLoading", false);
          this.$data.isLoading = false;
          errorsService.handleErrors(this, error);
        });
    }

    setOptIn(optIn: IOptInModel) {
      this.$data.isLoading = true;
      this.$data.errors = [];

      const url: string = this.$data.RCEnvironment.VUE_APP_ACCOUNT_API_URL + "newsletter/optin-user";

      accountService.post<IOptInRequestModel, IOptInRequestResponseModel>(this, url, { ListId: optIn.ListId, IsOptIn: !optIn.IsOptIn, IsG2GOptIn: true }, { headers: { Authorization: "Bearer " + this.$store.getters.token.Value } })
        .then(() => {
          this.$data.isLoading = false;
          optIn.IsOptIn = !optIn.IsOptIn;
        })
        .catch(error => {
          this.$data.isLoading = false;

          if (error != null && error.data.ErrorMessages != null && error.data.ErrorMessages.length) {
            this.$data.errors = error.data.ErrorMessages;
          }
        });
    }
    
    destroyed() {
      this.$data.unwatch();
    }
  }
